import React, { useState } from 'react';
import { useTask } from '../../context/TaskContext';
import { FaSave, FaTimes } from 'react-icons/fa';
import './TaskForm.css';

const TaskForm = ({ taskToEdit, onClose }) => {
  const { createTask, updateTask } = useTask();
  const [formData, setFormData] = useState({
    title: taskToEdit?.title || '',
    description: taskToEdit?.description || '',
    status: taskToEdit?.status || 'todo',
    priority: taskToEdit?.priority || 'medium',
    dueDate: taskToEdit?.dueDate ? taskToEdit.dueDate.split('T')[0] : '',
    tags: taskToEdit?.tags?.join(', ') || ''
  });

  const { title, description, status, priority, dueDate, tags } = formData;

  const onChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    
    const taskData = {
      title,
      description,
      status,
      priority,
      dueDate: dueDate || null,
      tags: tags.split(',').map(tag => tag.trim()).filter(tag => tag)
    };

    let success;
    if (taskToEdit) {
      success = await updateTask(taskToEdit._id, taskData);
    } else {
      success = await createTask(taskData);
    }

    if (success) {
      onClose();
    }
  };

  return (
    <div className="task-form-container card">
      <div className="task-form-header">
        <h3>{taskToEdit ? 'Edit Task' : 'Create New Task'}</h3>
      </div>
      
      <form onSubmit={onSubmit} className="task-form">
        <div className="form-group">
          <label className="form-label">Title *</label>
          <input
            type="text"
            name="title"
            value={title}
            onChange={onChange}
            className="form-control"
            placeholder="Task title"
            required
          />
        </div>

        <div className="form-group">
          <label className="form-label">Description</label>
          <textarea
            name="description"
            value={description}
            onChange={onChange}
            className="form-control"
            placeholder="Task description"
            rows="4"
          />
        </div>

        <div className="form-row">
          <div className="form-group">
            <label className="form-label">Status</label>
            <select
              name="status"
              value={status}
              onChange={onChange}
              className="form-control"
            >
              <option value="todo">To Do</option>
              <option value="in-progress">In Progress</option>
              <option value="completed">Completed</option>
            </select>
          </div>

          <div className="form-group">
            <label className="form-label">Priority</label>
            <select
              name="priority"
              value={priority}
              onChange={onChange}
              className="form-control"
            >
              <option value="low">Low</option>
              <option value="medium">Medium</option>
              <option value="high">High</option>
            </select>
          </div>

          <div className="form-group">
            <label className="form-label">Due Date</label>
            <input
              type="date"
              name="dueDate"
              value={dueDate}
              onChange={onChange}
              className="form-control"
            />
          </div>
        </div>

        <div className="form-group">
          <label className="form-label">Tags (comma separated)</label>
          <input
            type="text"
            name="tags"
            value={tags}
            onChange={onChange}
            className="form-control"
            placeholder="work, urgent, personal"
          />
        </div>

        <div className="form-actions">
          <button type="submit" className="btn btn-primary">
            <FaSave /> {taskToEdit ? 'Update' : 'Create'} Task
          </button>
          <button type="button" onClick={onClose} className="btn btn-outline">
            <FaTimes /> Cancel
          </button>
        </div>
      </form>
    </div>
  );
};

export default TaskForm;
